module.exports = __webpack_public_path__ + "img/comboticket logo@2x.4766f0ba.png";